<template>
    <div class="home-vacancy-section" v-if="pageSetup != null">
        <div class="container">
            <div class="inner-content">
                <div class="desc-col">
                    <p v-html="pageSetup.vacancy_desc"></p>
                </div>
                <div class="vacancy-icon"><img :src="pageSetup.vacancy_icon" alt=""></div>
                <div class="col-info">
                    <h3>{{ pageSetup.vacancy_title }}</h3>
                    <router-link to="/vacancy" class="link-btn-more">
                        <span>{{  pageSetup.vacancy_btn_desc }}</span>
                        <svgIcon name="arrow-go-right"/>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'home-vacancy-section',
        components: {
            svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            pageSetup: 'loadIndexPage',
        }),
        methods: {
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/home-page/home-vacancy.scss';
    @import '@/styles/components/home-page/respond/home-vacancy-respond.scss';
</style>